import { render, staticRenderFns } from "./ProductThree.vue?vue&type=template&id=6d689686&"
import script from "./ProductThree.vue?vue&type=script&lang=js&"
export * from "./ProductThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d689686')) {
      api.createRecord('6d689686', component.options)
    } else {
      api.reload('6d689686', component.options)
    }
    module.hot.accept("./ProductThree.vue?vue&type=template&id=6d689686&", function () {
      api.rerender('6d689686', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/products/ProductThree.vue"
export default component.exports